import React, { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { Scaffold } from 'layouts';
import { FormPageHeader } from 'components/Shared';
import { DriverUpdateForm } from 'components/Pages/Drivers';
import * as S from './styles';

export const DriverUpdatePage: React.FC = () => {
  const { id } = useParams() as { id: string };
  const navigate = useNavigate();

  const { loading } = useSelector((state: RootState) => state.fetchDriver);

  const onUpdate = useCallback((): void => {
    navigate('/configuracoes/motoristas');
  }, [navigate]);

  return (
    <Scaffold>
      <S.PageContainer>
        <S.MainPanel>
          <FormPageHeader
            title="Editar motorista"
            icon={<S.UserRectangleIcon />}
            isLoading={loading}
            actions={
              <S.LinkButton size="small" to="/configuracoes/motoristas">
                <S.ArrowLeftIcon /> Voltar
              </S.LinkButton>
            }
          />
          <DriverUpdateForm driverId={id} onUpdate={onUpdate} />
        </S.MainPanel>
      </S.PageContainer>
    </Scaffold>
  );
};
